import { defineMessages } from 'react-intl';

const scope = 'co_browse_actions';

export default defineMessages({
  accept: {
    id: `${scope}.accept`,
    defaultMessage: 'Accept',
  },
  decline: {
    id: `${scope}.decline`,
    defaultMessage: 'Decline',
  },
});
